import React, { Component } from "react";
import { Div, Text, Row, Col } from "atomize";

import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import ImageLink from "../common/ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

export default class EngagementTestimonial extends Component {
  render() {
    const { content } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer p={{ x: { xs: "0", md: "2.5rem" } }}>
          <Div m={{ t: { xs: "9.25rem", md: "13.375rem" } }}>
            <Text textSize="title2" textWeight="bold" p={{x: {xs: "1.5rem", md: "0"}}}>
              {content.heading}
            </Text>
            <Div
              d="flex"
              flexDir={{ xs: "column-reverse", md: "row" }}
              m={{ t: "2.1rem" }}
            >
              <Div
                bg="#1F1F1F"
                d="flex"
                flexDir={{ xs: "column", lg: "row" }}
                flexGrow="1 1 50%"
                align={{ xs: "inherit", lg: "center" }}
                p={{ y: {xs: "4.25rem", lg: "88px"}, x: "64px" }}
                m={{t: {xs: "5px", md: "0"}}}
              >
                <Div flexGrow="1">
                  <ImageLink link={content.img1Link}>
                    <Div
                      // flexGrow="1"
                      bgImg={content.img1}
                      p={{ b: "117px" }}
                      bgSize="contain"
                      bgPos="center"
                      bgRepeat="no-repeat"
                    ></Div>
                  </ImageLink>
                </Div>
                
                <Div d={{xs:"none", lg: "block"}} m={{x: "52.5px"}} bg="gray700" w="2px" h="5rem"></Div>
                <Div d={{xs:"block", lg: "none"}} m="52.5px auto" bg="gray700" h="1px" w="10rem"></Div>
                
                <Div flexGrow="1">
                  <ImageLink link={content.img2Link}>
                    <Div
                      flexGrow="1"
                      bgImg={content.img2}
                      p={{ b: "118px" }}
                      bgSize="contain"
                      bgPos="center"
                      bgRepeat="no-repeat"
                    ></Div>
                  </ImageLink>
                </Div>
              </Div>
              <Div
                m={{ l: { xs: "0", md: "1.25rem" } }}
                flexGrow="1 1 50%"
                bg="#1F1F1F"
                p={{ t: "3.75rem", x: {xs: "1.5rem", md: "2rem"}, b: "4.5rem" }}
              >
                <Text textSize="subheader5" textWeight="bold">
                  "{content.subHeading}"
                </Text>
                <Text
                  m={{ t: ".4rem", b: ".875rem" }}
                  style={{ lineHeight: "24px" }}
                  textColor="#D9D9D9"
                >
                  {content.text}
                </Text>
                <Text fontFamily="secondary" textWeight="bold">
                  - {content.user} | {content.review}
                </Text>
              </Div>
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
